// "Live now" -- a small marker under the card header while a show is on air,
// with a credit for whoever is verifying squares when we know who that is.
//
// Deliberately a credit and not a banner: one LIVE marker, the faces, the names.
//
// The marker used to be hidden unless the hosts service could name somebody,
// which meant it vanished from every visitor's page three minutes after the
// last time an admin touched the panel -- and stayed gone until the next square
// was ticked. On air is on air: the marker shows, and the faces join it when
// there are faces to show.
import React, { useState } from 'react';
import useLiveShow, { shouldShowHosts } from './liveShowStore';
import './LiveShow.css';

const HostAvatar = ({ host }) => {
  // A Discord avatar can 404 long after the URL was handed to us (the user
  // changed it, the hash went stale). Falling back to an initial keeps the row
  // from collapsing into a ragged gap.
  const [broken, setBroken] = useState(false);
  const initial = host.name.trim().charAt(0).toUpperCase() || '?';

  if (!host.avatarUrl || broken) {
    return <span className="wsb-host-avatar wsb-host-initial" aria-hidden="true">{initial}</span>;
  }

  return (
    <img
      className="wsb-host-avatar"
      src={host.avatarUrl}
      alt=""
      width="34"
      height="34"
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setBroken(true)}
    />
  );
};

const LiveHostsStrip = () => {
  const live = useLiveShow();
  if (!shouldShowHosts(live)) return null;

  const hasHosts = live.hosts.length > 0;

  return (
    <div className="wsb-hosts" data-html2canvas-ignore="true">
      <span className="wsb-hosts-live">
        <span className="wsb-hosts-live-dot" aria-hidden="true" />
        Live now
      </span>
      {hasHosts ? (
        <>
          <span className="wsb-hosts-label">Tonight&rsquo;s hosts</span>
          <ul className="wsb-hosts-list">
            {live.hosts.map((host) => (
              <li className="wsb-host" key={host.id} title={host.name}>
                <HostAvatar host={host} />
                <span className="wsb-host-name">{host.name}</span>
              </li>
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
};

export default LiveHostsStrip;
